import { Component, input } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent } from '@camelot/ui';

import { TimeEntryType } from '../../services/dto/time-entry-type';
import { CamTranslationPlanning } from '../../translation.service';

export const timeEntryTypeLabel = (timeEntryType: TimeEntryType) =>
  `planning.time-entry-type.${TimeEntryType[timeEntryType]?.toLowerCase() ?? 'unknown'}`;

@Component({
  imports: [BadgeComponent, TranslatePipe],
  selector: 'cam-time-entry-type',
  templateUrl: './time-entry-type.component.html',
})
export class TimeEntryTypeComponent {
  type = input.required<number | TimeEntryType>();

  constructor() {
    CamTranslationPlanning.getInstance();
  }

  public label() {
    return timeEntryTypeLabel(this.type());
  }
  public badgeType() {
    switch (this.type()) {
      case TimeEntryType.Work:
        return 'primary';
      case TimeEntryType.Transport:
        return 'info';
      default:
        return 'secondary';
    }
  }
}
